<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="设备组名称">
              <a-input placeholder="请输入设备组名称" v-debounce="searchQuery" v-model="queryParam.groupName"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="切换方式">
              <j-multi-select-tag
                dictCode="dev_switch_type"
                placeholder="请选择切换方式"
                type="checkbox"
                v-model="queryParam.switchType"
              />
            </a-form-item>
          </a-col>-->
          <a-col :lg="5" :md="6" :sm="24" :xl="4">
            <a-form-item>
              <j-checkbox
                :options="[{
                label:'只看需要切换',
            value:'1'
          }]"
                @change="searchQuery"
                v-model="queryParam.needSwitch"
              ></j-checkbox>
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="6" :sm="24" :xl="4">
            <a-form-item label="是否启用">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="is_open"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.planStatus"
              ></j-multi-select-tag>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增设备组</a-button>
      <a-button @click="handleExportXls('设备运行切换计划')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:false}"
        @change="handleTableChange"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="devSlot" slot-scope="text, record">
          <a-tag
            :key="index"
            @click="devRunningInfo(record.devid.split(',')[index])"
            v-for="(item, index) in record.devid_dictText.split(',')"
          >{{ item }}</a-tag>
        </span>

        <span slot="needSlot" slot-scope="text, record">
          <a-tag color="#ff4d4f" v-if="record.needSwitch == 1">需要切换</a-tag>
          <a-tag color="#52c41a" v-else>无需切换</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEnable(record.id, 'Y')" v-if="record.planStatus === 'N'">启用</a>
          <a @click="handleEnable(record.id, 'N')" v-if="record.planStatus === 'Y'">停用</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-switch-plan-modal @ok="modalFormOk" ref="modalForm"></dev-switch-plan-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevSwitchPlanModal from './modules/DevSwitchPlanModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'DevSwitchPlanList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevSwitchPlanModal
    },
    data () {
      return {
        description: '设备运行切换计划管理页面',
        queryParam: {
          needSwitch: '1',
        },
        // 表头
        columns: [
          {
            title: '设备',
            align: "center",
            dataIndex: 'devid_dictText',
            scopedSlots: { customRender: 'devSlot' },
            width: '25%',
          },
          {
            title: '设备组位号',
            align: "center",
            dataIndex: 'groupTag',
            sorter: true,
          },
          {
            title: '设备组名称',
            align: "center",
            dataIndex: 'groupName',
            sorter: true,
          },
          {
            title: '切换方式',
            align: "center",
            dataIndex: 'switchType_dictText',
            sorter: true,
          },
          {
            title: '需要切换',
            align: "center",
            dataIndex: 'needSwitch',
            scopedSlots: { customRender: 'needSlot' },
            sorter: true,
          },
          {
            title: '建议',
            align: "center",
            dataIndex: 'needSwitchContent',
            width: 220,
          },
          //   {
          //     title: '运行时长',
          //     align: "center",
          //     dataIndex: 'runningTime'
          //   },
          //   {
          //     title: '切换周期',
          //     align: "center",
          //     dataIndex: 'cycle'
          //   },
          //   {
          //     title: '周期单位',
          //     align: "center",
          //     dataIndex: 'cycleUnit_dictText'
          //   },
          //   {
          //     title: '周期(小时计)',
          //     align: "center",
          //     dataIndex: 'cycleHours'
          //   },
          //   {
          //     title: '上次切换时间',
          //     align: "center",
          //     dataIndex: 'lastTime'
          //   },
          //   {
          //     title: '下次切换时间',
          //     align: "center",
          //     dataIndex: 'nextTime'
          //   },
          {
            title: '是否启用',
            align: "center",
            dataIndex: 'planStatus',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['planStatus'], text) : ''),
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 160,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/maintenance/devSwitch/list",
          delete: "/maintenance/devSwitch/delete",
          edit: "/maintenance/devSwitch/edit",
          deleteBatch: "/maintenance/devSwitch/deleteBatch",
          exportXlsUrl: "/maintenance/devSwitch/exportXls",
          importExcelUrl: "maintenance/devSwitch/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.$set(this.dictOptions, 'planStatus', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'devid', text: '设备', dictCode: '' })
        fieldList.push({ type: 'string', value: 'groupTag', text: '设备组位号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'groupName', text: '设备组名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'switchType', text: '切换方式', dictCode: 'dev_switch_type' })
        fieldList.push({ type: 'int', value: 'runningTime', text: '运行时长', dictCode: '' })
        fieldList.push({ type: 'double', value: 'cycle', text: '切换周期', dictCode: '' })
        fieldList.push({ type: 'string', value: 'cycleUnit', text: '周期单位', dictCode: 'dev_switch_cycle' })
        fieldList.push({ type: 'double', value: 'cycleHours', text: '周期(小时计)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'reminderTime', text: '提醒时间(分)', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'lastTime', text: '上次切换时间' })
        fieldList.push({ type: 'datetime', value: 'nextTime', text: '下次切换时间' })
        fieldList.push({ type: 'switch', value: 'planStatus', text: '计划状态' })
        this.superFieldList = fieldList
      },
      handleEnable: function (id, enable) {
        httpAction(this.url.edit, { id, planStatus: enable }, 'put').then((res) => {
          if (res.success) {
            this.$emit('ok');
            this.loadData();
          } else {
            this.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        });
      },
      devRunningInfo (id) {

      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>